import styled from '@emotion/styled'
import {Box, Paper} from '@mui/material'
import {ArrowForward, Edit, ExpandCircleDownOutlined} from '@mui/icons-material'
import Typography from '@mui/material/Typography'
import {StyledWarningAmberOutlinedIcon} from '../ProjectList/ProjectListLandingStyles'

export const StyledPaper = styled(Paper)(({theme}) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  boxShadow: 'none',
  transition: 'box-shadow 0.3s ease-in-out',
  cursor: 'pointer'
}))

export const StyledGroupTablePaper = styled(Paper)(({theme}) => ({
  background: theme.palette.grey[100]
}))

export const GappedRow = styled('div')(({isClickable}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: isClickable ? 'pointer' : 'default'
}))

export const StyledExpandIcon = styled(ExpandCircleDownOutlined, {
  shouldForwardProp: (prop) => prop !== 'isExpanded'
})(({theme, isExpanded}) => ({
  fontSize: theme.typography.h6.fontSize,
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.3s ease',
  color: theme.palette.hpBaseDark
}))

export const StyledEditIcon = styled(Edit)(({theme}) => ({
  fontSize: theme.typography.pxToRem(18)
}))

export const StyledArrowForwardIcon = styled(ArrowForward)(({theme}) => ({
  fontSize: theme.typography.pxToRem(18)
}))

export const StyledClientName = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightMedium
}))

export const StyledProjectNameContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center'
}))

export const StyledCompletedProjectContainer = styled(Box)(({theme}) => ({
  marginLeft: theme.spacing(3)
}))

export const StyledWarningIcon = styled(StyledWarningAmberOutlinedIcon)(({theme}) => ({
  marginRight: theme.spacing(0)
}))
